import { getNoteLabel } from 'quotes/components/QuotePartAddNote/utils';
import { QuotePartNoteType } from 'quotes/enums';
import { IQuotePart } from 'quotes/types';

const DEFAULT_NOTE_TYPES = [
  QuotePartNoteType.UNDISCARDABLE_ITEM,
  QuotePartNoteType.DEFAULT,
  QuotePartNoteType.LEAD_TIME,
];

const ALTERNATE_VERSION_NOTE_TYPES = [
  QuotePartNoteType.BUYER,
  QuotePartNoteType.PICKER,
  QuotePartNoteType.SUPSHIP,
];

// Mirrors the Add Note availability gate (QuotePartAddNote.tsx): the alternate-version note types
// are offered only when every selected line has the alternate version enabled.
export const getAvailableNoteTypes = (quoteParts: IQuotePart[]): QuotePartNoteType[] => {
  // An empty selection must behave like a missing one: `[].every()` is vacuously true, which would
  // otherwise offer the alternate-version types for zero lines (visible while the drawer lingers
  // open after a successful removal deselects every row).
  const isAlternateVersionEnabled =
    !!quoteParts?.length &&
    quoteParts.every((quotePart) => quotePart.alternateVersionEnabled === 1);

  return isAlternateVersionEnabled
    ? [...DEFAULT_NOTE_TYPES, ...ALTERNATE_VERSION_NOTE_TYPES]
    : [...DEFAULT_NOTE_TYPES];
};

// The undiscardable item note has no suffix-less translation key, unlike the other types.
export const getNoteTypeLabel = (type: QuotePartNoteType) =>
  getNoteLabel(type, QuotePartNoteType.UNDISCARDABLE_ITEM === type);
